import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=68491a54&scoped=true&"
import script from "./PrintPage.vue?vue&type=script&lang=js&"
export * from "./PrintPage.vue?vue&type=script&lang=js&"
import style0 from "./PrintPage.vue?vue&type=style&index=0&id=68491a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68491a54",
  null
  
)

export default component.exports